import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center cursor-pointer",
      className
    )}
    style={{ 
      WebkitTapHighlightColor: 'transparent',
      WebkitTouchCallout: 'none',
      WebkitUserSelect: 'none',
      userSelect: 'none',
      pointerEvents: 'auto',
      touchAction: 'none',
    }}
    {...props}
  >
    <SliderPrimitive.Track 
      className="relative h-3 w-full grow overflow-hidden rounded-full bg-secondary cursor-pointer"
      style={{
        pointerEvents: 'auto',
        touchAction: 'none',
      }}
    >
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb 
      className="block h-7 w-7 rounded-full border-2 border-primary bg-background shadow-lg ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:scale-110 touch-manipulation disabled:pointer-events-none disabled:opacity-50 cursor-grab active:cursor-grabbing" 
      style={{
        WebkitTapHighlightColor: 'transparent',
        WebkitTouchCallout: 'none',
        pointerEvents: 'auto',
        zIndex: 10,
        WebkitUserSelect: 'none',
        userSelect: 'none',
        touchAction: 'none',
      }}
    />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
